import styles from "../styles/Why_hire.module.scss";

//<--------->

function WhyHire(props) {
  return (
    <div>
      <MainContainer />
    </div>
  );
}

function MainContainer() {
  return (
    <div className={styles.maincontainer}>
      <TitleDescription />
      <ServicesItemsRow />
    </div>
  );
}

function TitleDescription() {
  return (
    <div className={styles.titledescriptioncontainer}>
      <div className={styles.title}>Why Hire Me ? </div>
      <div className={styles.description}>Some reasons to hire me !</div>
    </div>
  );
}

function ServicesItemsRow() {
  return (
    <div className={styles.allservices}>
      <ServiceItem />
      <ServiceItem />
      <ServiceItem />
    </div>
  );
}

function ServiceItem() {
  return (
    <div className={styles.servicecontainer}>
      <div className={styles.serviceitemline}></div>
      <div className={styles.servicetitledescriptioncontainer}>
        <div className={styles.serviceitemnum}>I Provide Great Insights</div>
        <div className={styles.serviceitemtitle}>
          Insights are important when you're building a modern product during
          the design process i can make changes that will reflect the perfect
          product
        </div>
      </div>
    </div>
  );
}

export default WhyHire;
